import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { HashRouter } from 'react-router-dom'
import store from './store'
import { Provider } from 'react-redux'
import './assets/scss/style.scss'

// import ReactGA from "react-ga4"
// ReactGA.initialize(process.env.REACT_APP_GA4_KEY);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
